<template>
  <div>
    <div class="container-block" style="margin: 15px 0">
      <a-form-model layout="inline">
        <a-form-model-item label="配方">
          <a-input
            style="width: 200px"
            placeholder="输入配方名称/代码"
            @pressEnter="getList(search)"
            v-model="search.formulaKeyword"
          />
        </a-form-model-item>
        <a-form-model-item label="动物类型">
          <animal-select
            style="width: 200px"
            @change="anmimlChange"
            :val="animal"
          />
        </a-form-model-item>
        <!-- 新增线路搜索条件 -->
        <a-form-model-item label="线路">
          <a-select style="width: 150px" v-model="search.lineId" placeholder="选择线路" allow-clear>
            <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
              {{ el.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="分类">
          <a-select allowClear v-model="search.typeClassify" style="width: 200px" placeholder="选择配方分类">
            <a-select-option :value="0"> 未分类 </a-select-option>
            <a-select-option :value="1"> 自产配方 </a-select-option>
            <a-select-option :value="2"> 代工配方 </a-select-option>
            <a-select-option :value="3"> 定制配方 </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select style="width: 150px" v-model="search.status">
            <a-select-option :value="0">显示</a-select-option>
            <a-select-option :value="1">隐藏</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" @click.enter="() => getList(search)"
              >查询</a-button
            >
            <a-button @click="resetList">清空</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>

    <!-- <BtnControl :selectedRowKeys="selectedRowKeys" pageType="blend"/> -->
    <div class="container-block" style="padding-bottom: 0">
      <a-row style="margin-bottom: 15px">
        <a-space>
          <!-- <a-button type="primary" @click="toggleModalVisible">新建</a-button>
          <a-button
            :disabled="deleteDisable"
            type="danger"
            ghost
            @click="deleteFormulas"
            >批量删除</a-button
          > -->
          <template v-for="el in buttonList">
            <template v-if="el.code.indexOf('third') < 0">
              <a-button
                :key="el.id"
                :type="el.code === 'add' ? 'primary' : el.code === 'delete' ? 'danger' : ''"
                :class="{enable: !isDelete && el.code === 'show',forbidden: !isDelete && el.code === 'hide'}"
                :ghost="el.code === 'delete'"
                :disabled="(isDelete && (el.code === 'delete' || el.code === 'simulation' || el.code === 'show' || el.code === 'hide'))"
                @click="clickFunc(el.path,el.code)"
              >
                {{el.name}}
              </a-button>
            </template>
          </template>
          <a-button :disabled='isDelete' @click="openSetDistribution">批量设置配销差</a-button>
          <template v-if="selectedRowKeys.length > 0">
            <a-tag> 已选择 {{ selectedRowKeys.length }} 项目 </a-tag>
          </template>
        </a-space>
      </a-row>
      <a-table
        :columns="columns"
        :loading="feedLoading"
        :data-source="list.records"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange,getCheckboxProps }"
        :row-key="(record) => record.id"
        :pagination="pagination"
        @change="listChange"
      >
        <a-tooltip slot="typeClassify" slot-scope="t">
          <template slot="title">{{ typeClassName(t) }}</template>
          {{ typeClassName(t) }}
        </a-tooltip>
        <a slot="sortNum" slot-scope="t,record"  @click="handlerMore({'key': 2},record)">
          {{ t || t === 0 ? t : '排序' }}
        </a>
        <a-tooltip slot="formulaName" slot-scope="text, record">
          <template slot="title">
            {{ text }}
          </template>
          <a @click="goEditor(record)">{{ text }}</a>
        </a-tooltip>
        <template slot="version" slot-scope="text, record" v-if="text > 0">
          <a-popover title="切换版本" trigger="click">
            <a
              class="ant-dropdown-link"
              @click="(e) => getVersion(record.id, e)"
              >{{ text }}</a
            >
            <a-list
              style="width: 350px;"
              :loading="versionLoading"
              class="dropdown-list"
              size="small"
              :data-source="version"
              slot-scope="item, index"
              :rowKey="index"
              slot="content"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <span class="list-item">
                  V{{ item.version }} [{{ item.createTime }}]
                </span>

                 <!-- 曾静---------------------->
                <div>
                  <a-button
                    :loading="btnLoading&&btnId===item.id"
                    slot="extra"
                    :disabled="item.status === 1"
                    type="primary"
                    size="small"
                    @click="(e) => setVersion(item.id, record.id)"
                    >{{ item.status === 1 ? "已激活" : "激活" }}</a-button
                  >
                  <a-button
                    v-if="item.status === 0"
                    size="small"
                    type="danger"
                    style="margin-left: 6px"
                    @click="deleteItem(item.id)"
                    >删除</a-button
                  >
                </div>

              </a-list-item>
            </a-list>
          </a-popover>
        </template>
        <template slot="option" slot-scope="text, record">
          <a @click="goEditor(record)">配方设计</a>
          <a-divider type="vertical" />
          <a @click="copyActions(record.id)">复制</a>
          <a-divider type="vertical" />
          <a @click="coverFormula(record.id, record)">覆盖</a>
          <a-divider type="vertical" />
          <a @click="() => getVisionList(record)">版本</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              ...
            </a>
            <a-menu slot="overlay" @click="e => handlerMore(e,record)">
              <a-sub-menu key="report" title="报表">
                <a-menu-item key="report-1">配方报表</a-menu-item>
                <a-menu-item key="report-2">生产报表</a-menu-item>
                <a-menu-item key="report-3">配方产品报表</a-menu-item>
                <a-menu-item key="report-4">生产产品报表</a-menu-item>
              </a-sub-menu>
              <a-menu-item key="2">
                排序
              </a-menu-item>
              <a-menu-item key="3">
                查看
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <!-- <a v-else :class="{ disabled: !record.version > 0 }">报表</a> -->
          <!--<a-divider type="vertical" />
          <a @click="editorInfo(record)">编辑信息</a>-->
        </template>
      </a-table>
    </div>
    <compound-create-modal
      :hidden="modalVisible"
      @ok="create"
      @cancel="toggleModalVisible"
    />
    <compound-create-modal
      :hidden="editorVisible"
      @ok="update"
      @cancel="cancelUpdate"
      :item="selectItem"
    />
    <compound-modal
      :hidden="detailVisible"
      :formulaId="formulaId"
      @cancel="toggleDetailVisible"
    />
    <copy-compound-modal
      :hidden="copyVisible"
      :formulaId="formulaId"
      @cancel="toggleCopyVisible"
      @ok="copyAction"
    />
    <vision-modal @refreshList="() => getList({current: pagination.current,pageSize: pagination.pageSize,...search})" />
    <sort-modal :hidden="sortModalVisible" @close="hideSortModal" :rowData="sortData" />
    <SetDistributionDifference :hidden="setDistributionVisible" @close="closeSetDistribution" :formulaIdList="selectedRowKeys" />
    <cover-compound-modal :hidden="coverVisible" :formulaId="formulaId" :formulaName="formulaName" :formulaCode="formulaCode" @cancel="toggleCoverVisible" @ok="coverAction" />
  </div>
</template>

<script>
import { nhfMixins } from "../untils";
import CompoundModal from "./modal/CompoundModal.vue";
import CompoundCreateModal from "./modal/CompoundCreateModal.vue";
import AnimalSelect from "./select/AnimalSelect.vue";
import CopyCompoundModal from "./modal/CopyCompoundModal.vue";
import VisionModal from './modal/VisionModal.vue'
import SortModal from './modal/SortModal.vue'
import SetDistributionDifference from './modal/SetDistributionDifference.vue'
import CoverCompoundModal from './modal/CoverCompoundModal.vue'
// import BtnControl from '@/components/Common/components/BtnControl.vue';
const columns = [
  {
    title: "配方名称",
    dataIndex: "formulaName",
    scopedSlots: { customRender: "formulaName" },
    width: 140,
    ellipsis: true,
  },
  {
    title: "分类",
    dataIndex: "typeClassify",
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: "typeClassify" },
  },
  {
    title: "代码",
    dataIndex: "formulaCode",
    width: 100,
    ellipsis: true,
  },
  {
    title: "动物类型",
    dataIndex: "animalTypeName",
    width: 100,
    ellipsis: true,
  },
  // {
  //   title: "版本",
  //   dataIndex: "version",
  //   scopedSlots: { customRender: "version" },
  //   align: "center",
  // },
  {
    title: "工厂名称",
    dataIndex: "factoryName",
    width: 120,
    ellipsis: true,
  },
  {
    title: "排序",
    dataIndex: "sortNum",
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: "sortNum" },
  },
  {
    title: "用户",
    dataIndex: "userName",
    width: 80,
    ellipsis: true,
  },
  {
    title: "编辑时间",
    align: "center",
    dataIndex: "updateTime",
    sorter: (a, b) =>
      new Date(a.updateTime).getTime() - new Date(b.updateTime).getTime(),
    sortDirections: ["descend", "ascend"],
    width: 180,
    ellipsis: true,
  },
  {
    title: "备注",
    dataIndex: "remark",
    width: 100,
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "option",
    width: 240,
    align: "center",
    scopedSlots: { customRender: "option" },
  },
];
export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    CompoundCreateModal,
    AnimalSelect,
    CompoundModal,
    CopyCompoundModal,
    VisionModal,
    SortModal,
    SetDistributionDifference,
    CoverCompoundModal,
    // BtnControl,
  },
  mixins: [nhfMixins],
  data() {
    return {
      setDistributionVisible:false,
      buttonList: [],
      btnLoading: false,
      btnId: '',
      selectItem: {},
      editorVisible: false,
      detailVisible: false,
      copyVisible: false,
      columns,
      list: {},
      search: {status: 0},
      filterData: {},
      animal: [],
      formulaId: null,
      copyId: null,
      feedLoading: false,
      versionLoading: false,
      version: [],
      sortModalVisible: false,
      sortData: {},
      coverVisible: false,
      formulaName: '',
      formulaCode: '',
      // 新增线路数据
      lineList: []
    };
  },
  mounted() {
    this.getList(this.search);
    this.getBtn(this.btnList);
    // 获取线路列表
    this.getLineList();
  },
  watch: {
    $route() {
      this.getList(this.search);
    },
    btnList:{
      handler(val){
        this.getBtn(val)
      },
      deep: true
    },
  },
  computed: {
    deleteDisable() {
      return this.selectedRowKeys.length === 0;
    },
    isDelete(){
      return this.selectedRowKeys.length === 0
    },
    isEdit(){
      return this.selectedRowKeys.length !== 1
    }
  },
  methods: {
    typeClassName(t){
      return this.classNames[t]
    },
    openSetDistribution(){
      this.setDistributionVisible = true
    },
    closeSetDistribution(type){
      if(type) this.getList(this.search);
      this.setDistributionVisible = false
    },
    handlerMore({key},record){
      console.log('key',key)
      console.log('record',record)
      // 报表子菜单
      if((key + '').indexOf('report-') === 0){
        const reportKey = Number((key + '').split('-')[1])
        this.viewReport({ key: reportKey }, record.id)
      } else if(key == 1) {
        this.getVisionList(record)
      }else if(key == 2) {
        this.sortData = record
        this.showSortModal()
      }else if(key == 3) {
        this.viewCompound(record.id)
      }
    },
    hideSortModal(type){
      if(type) this.getList(this.search)
      this.sortModalVisible = false
    },
    showSortModal(){
      this.sortModalVisible = true
    },
    async updateStatus(type){
      this.$confirm({
        title: "提示",
        content: type === 'show' ? "确认显示选中的配方吗？" : '确认隐藏选中的配方吗？',
        okText: "继续",
        cancelText: "取消",
        onOk: async () => {
          let data = {
            ids: this.selectedRowKeys.join(','),
            status: type === 'show' ? 0 : 1
          }
          await this.fetchPost({
            actions: this.batchUpdateFormulaStatus,
            data,
            loading: "feedLoading",
          });
          this.cleanSelect()
          this.getList(this.search)
        }
      })
    },
    clickFunc(functionName,type){
      this[functionName](type)
    },
    getBtn(val){
      let formula = val.find(el => el.code === 'blend') || {}
      if(formula.children){
        let simulation = formula.children.find(el => el.code === 'simulation')
        // let ls = formula.children.filter(el => el.code === 'simulation')
        this.hasSimulationBtn = simulation ? true : false
        this.buttonList = formula.children || []
      }
    },
    async copyAction(data) {
      this.toggleCopyVisible();
      let { total, pageSize } = this.pagination;
      let current = Math.ceil(total / pageSize);
      window.localStorage.setItem("blenCurrent", current);
      window.localStorage.setItem("blenSize", pageSize);
      data.current = current;
      await this.fetchPost({
        actions: this.confirmCopyFormulaMix,
        data,
        loading: "feedLoading",
      });
      await this.getList(this.search);
    },
    async setVersion(productId, formulaId) {
      this.btnId = productId
      this.btnLoading = true
      let res = await this.fetchGet({
        actions: this.activationFormulaMixHisVersion,
        data: { productId },
      });
      this.getVersion(formulaId);
      let {success} = res || {}
      if(success){
        this.$message.success("版本切换成功");
        let {pageSize,current} = this.pagination
        let params = {size: pageSize,current,...this.search}
        this.getList({ ...params });
        this.btnLoading = false
        this.btnId = ''
      }else{
        this.btnLoading = false
        this.btnId = ''
      }
    },
    async getVersion(formulaId) {
      await this.fetchGet({
        actions: this.getFormulaHisVersionList,
        data: { formulaId },
        name: "version",
        loading: "versionLoading",
      });
    },
    copyActions(id) {
      this.toggleCopyVisible();
      if (this.copyVisible) {
        this.formulaId = id;
      }
    },
    toggleCopyVisible() {
      this.copyVisible = !this.copyVisible;
    },
    viewReport({ key }, formulaId) {
      // let routeUrl = this.$router.resolve({
      //   path:`/nhf-mix-report?id=${id}&formulaReportType=${formulaReportType}`
      // })
      // window.open(routeUrl.href, '_blank')
      let url = [
        '/nhf-app/formulahis/exportMixFormulaExcelReport',
        '/nhf-app/formulahis/exportMixFormulaProExcelReport',
        "/nhf-app/formulahis/exportMixFormulaProductExcelReport",
        "/nhf-app/formulahis/exportProduceMixFormulaProExcelReport",
      ]
      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
      this.$fileDownload(url[key - 1], { formulaId,aliasFlag }).catch((e) => {
        e.message && this.$message.error(e.message);
      });
    },
    goEditor({ id }) {
      let { current, pageSize } = this.pagination;
      window.localStorage.setItem("blenCurrent", current);
      window.localStorage.setItem("blenSize", pageSize);
      this.$router.push(`/nhf-blend-editor?id=${id}`);
    },

    editorInfo(item) {
      this.selectItem = item;
      this.toggleEditorVisible();
    },

    toggleEditorVisible() {
      this.editorVisible = !this.editorVisible;
    },

    toggleDetailVisible() {
      this.detailVisible = !this.detailVisible;
    },

    viewCompound(formulaId) {
      this.formulaId = formulaId;
      this.$nextTick(() => {
        this.toggleDetailVisible();
      });
    },

    async create(arg = {}) {
      this.feedLoading = true;
      this.toggleModalVisible();
      let { formulaExtMix, ...values } = arg;
      let { total, pageSize } = this.pagination;
      let current = Math.ceil(total / pageSize);
      window.localStorage.setItem("blenCurrent", current);
      window.localStorage.setItem("blenSize", pageSize);
      let data = {
        ...values,
        formulaExtMix,
        factoryId: this.factoryId,
        current,
      };
      await this.fetchPost({
        actions: this.formulaBlendSave,
        data,
      });
      this.getList(this.search);
    },

    resetList() {
      this.search = {status: 0};
      this.animal = [];
      this.getList(this.search);
    },

    listChange(page) {
      let {pageSize} = page || {}
      window.localStorage.setItem('blenSize',pageSize)
      this.getList({ ...this.tablePageChange(page), ...this.filterData ,...this.search});
    },

    anmimlChange(val) {
      this.animal = val;
      this.search.animalTypeCode = [...val].pop();
    },

    getList(arg = {}) {
      let current = window.localStorage.getItem("blenCurrent");
      let size = window.localStorage.getItem("blenSize");
      const data = {
        factoryId: this.factoryId,
        formulaType: 2,
        ...arg,
      };
      if (current) data.current = Number(current);
      if (size) data.size = Number(size);
      this.fetchGet({
        actions: this.myFormulaNhfPage,
        isList: true,
        data,
        name: "list",
        loading: "feedLoading",
      });
      window.localStorage.removeItem("blenCurrent");
      // window.localStorage.removeItem("blenSize");
    },
    cancelUpdate() {
      this.selectItem = null;
      this.toggleEditorVisible();
    },
    async update(data) {
      this.feedLoading = true;
      this.selectItem = null;
      this.toggleEditorVisible();
      await this.fetchPost({
        actions: this.mixUpdate,
        data,
      });
      this.getList(this.search);
    },
    async deleteFormulas(){
      this.$confirm({
        title: "提示",
        content: "确认将选中的配方删除吗？",
        okText: "继续",
        cancelText: "取消",
        onOk: async () => {
          let ids = this.selectedRowKeys.join(',')
          let res = await this.fetchPost({
            actions: this.removeFormulaIds,
            data: {ids},
          });
          let {code} = res || {}
          // this.$message[success ? "success" : "warn"](res.msg);
          if (code === 200) {
            this.cleanSelect();
            this.getList(this.search);
          }
        }
      })
    },
    // 曾静--------删除版本
    async deleteItem(id) {
      this.$confirm({
        title: "提示",
        content: <p style='color:red;padding:0;margin:0'>版本删除后，配方列表页将不再展示当前版本，<span style='color:#444'>你还要继续吗？</span></p>,
        okText: "继续",
        cancelText: "取消",
        onOk: async () => {
          let res = await this.$http.get(
            "/nhf-app/formulahis/delFormulaHisVersion?productId=" + id
          );
          const { success } = res;
          this.$message[success ? "success" : "warn"](res.msg);
          if (success) {
            this.cleanSelect();
            this.getVersion(id)
          }
        },
        onCancel() {},
      });
    },
    // 获取版本
    getVisionList(getVisionRaw){
      this.setState({getVisionRaw})
      this.toggleVisible('vision')
    },
    coverFormula(formulaId, record) {
      this.formulaId = formulaId;
      this.formulaName = record?.formulaName;
      this.formulaCode = record?.formulaCode;
      this.factoryId = record?.factoryId;
      this.$nextTick(() => {
        this.toggleCoverVisible();
      });
    },
    toggleCoverVisible() {
      this.coverVisible = !this.coverVisible;
    },
    coverAction() {
      this.$message.success('覆盖功能已执行');
      this.toggleCoverVisible();
    },
    // 新增获取线路列表的方法
    async getLineList() {
      try {
        const res = await this.$http.get('/nhf-core-data/line/list', { params: { current: 1, size: 10000 } });
        if (res.success) {
          this.lineList = res.data.records || [];
        }
      } catch (error) {
        console.error('获取线路列表失败:', error);
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.disabled {
  color: #888;
}
.list-item {
  font-size: 12px;
}
.dropdown-list {
  max-height: 300px;
  width: 240px;
  overflow: auto;
  margin: -10px;
}
.enable{
  background: #02830f;
  color: #fff;
  border: none;
  &:hover{
    background: #14811f;
  }
}
.forbidden{
  background: #f59a23;
  color: #fff;
  border: none;
  &:hover{
    background: #f7ab47;
  }
}
</style>
<style lang="scss">
.ant-popover{
  z-index: 0 ;
}
</style>
